import { render, staticRenderFns } from "./ParameterHistoricalTODComparison.vue?vue&type=template&id=5588f760"
import script from "./ParameterHistoricalTODComparison.vue?vue&type=script&lang=js"
export * from "./ParameterHistoricalTODComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports